
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col, Container, Card, Button, InputGroup, Form} from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';
import { toast } from "react-toastify";

import Select from 'react-select';

const Edit_Stud_Fees = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [ddlSection, setDdlSection] = useState([]);
  const [ddlAcademicYears, setDdlAcademicYears] = useState([]);
  const [errors, setErrors] = useState({});
  const [rowErrors, setRowErrors] = useState({});
  const [academicYear, setAcademicYear] = useState("");


  const [searchGR_No, setSearchGR_No] = useState();
  const [searchSection, setSearchSection] = useState();
  const [ddlGRNos, setDdlGRNos] = useState([]);
  const [ddlFeeComp, setDdlFeeComp] = useState([]);

  const [rcptDate, setRcptDate] = useState();

  const [showUpdateButtons, setShowUpdateButtons] = useState(false);

  // Header State
  const [headerData, setHeaderData] = useState({
    fw_id: '',
    year1: '',
    year2: '',
    section_id: '',
    gr_no: '',
    stud_name: '',
    std_div_name: '',
    std_id: '',
    div_id: ''
  });

// Middle table data 
  const [feeComponentRows, setFeeComponentRows] = useState([
  {
    fee_code: "",
    install_no: "",
    fee_amt: ""
  }
]);

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      section_id: '',
      gr_no: '',
      stud_name: '',
      std_id: '',
      div_id: '',
      std_div: '',
      year: '',
      fee_desc: '',
      install_no: '',
      bal_flag: '',
      rcpt_no: '',
      fee_amt: '',
      fw_amt: '',
    } 
  ]);
// fee receipt table
  const [feeReceiptRow, setFeeReceiptRow] = useState([
    {
      year1: '',
      section_id: '',
      fee_rcpt_no: '',
      gr_no: '',
      fee_rcpt_date: '',
      payment_mode: '',
      total_amt: '',
      status: '',
      cancel_rem: '',
      from_period_name: '',
      to_period_name: '',

    } 
  ]);

  const handleHeaderChange = (e) => {

    const { name, value } = e.target;

    setHeaderData(prev => ({ ...prev, [name]: value }));

    if (name === 'year1') {
       setHeaderData(prev => ({ ...prev, year2: Number(value) + 1 }));
    }

    setErrors(prev => ({ ...prev, [name]: "" }));

  };

  const handleFeeReceiptChange = (index, e) => {
    const { name, value } = e.target;

    setFeeReceiptRow(prev =>
      prev.map((row, i) =>
        i === index ? { ...row, [name]: value } : row
      )
    );
  };

  const handleFeeComponentChange = (index, e) => {
    const { name, value } = e.target;

    setFeeComponentRows((prev) =>
      prev.map((row, i) =>
        i === index
          ? { ...row, [name]: value }
          : row
      )
    );
  };

  const handleAddFeeComponent = async () => {
    const row = feeComponentRows[0];

    if (!academicYear) {
      toast.error("Please select Academic Year.");
      return;
    }

    if (!searchSection) {
      toast.error("Please select Section.");
      return;
    }

    // if (!searchGR_No) {
    //   toast.error("Please select GR No. / Student Name.");
    //   return;
    // }

    if (!row.fee_code) {
      toast.error("Please select Fee Description.");
      return;
    }

    if (!row.install_no || Number(row.install_no) <= 0) {
      toast.error("Please enter a valid Installment No.");
      return;
    }

    if (!row.fee_amt || Number(row.fee_amt) <= 0) {
      toast.error("Please enter a valid Fee Amount.");
      return;
    }

    const selectedFee = ddlFeeComp.find(
      (fee) =>
        String(fee.fee_code) === String(row.fee_code)
    );

    const payload = {
      year1: Number(academicYear),
      year2: Number(academicYear) + 1,
      section_id: searchSection,
      gr_no: searchGR_No,
      fee_code: row.fee_code,
      install_no: row.install_no,
      fee_amt: row.fee_amt
    };

    try {
      const response = await axios.post(
        `${BASE_URL}/api/add_fee_component`,
        payload
      );

      if (response.data.message !== "1") {
        toast.error("Unable to save new fee component.");
        return;
      }

      const newChildRow = {
        section_id: searchSection,
        gr_no: searchGR_No,
        stud_name: headerData.stud_name || "",
        std_id: "",
        div_id: "",
        std_div: "",
        year: academicYear,
        fee_code: row.fee_code,
        fee_desc: selectedFee?.fee_desc || "",
        install_no: row.install_no,
        bal_flag: "",
        rcpt_no: "",
        fee_amt: row.fee_amt,
        fw_amt: ""
      };

      setChildRows((prevRows) => {
        const validRows = prevRows.filter(
          (item) => item.fee_code
        );

        return [...validRows, newChildRow];
      });

      setFeeComponentRows([
        {
          fee_code: "",
          install_no: "",
          fee_amt: ""
        }
      ]);

      toast.success("New Fee Component added successfully.");

    } catch (error) {
      console.error(
        "Save New Fee Component Error:",
        error
      );

      toast.error(
        error.response?.data?.error ||
        "Error while saving new fee component."
      );
    }
  };

const fetchFeeDetails = async () => {
      
  try {

    setChildRows([]);
    setFeeReceiptRow([]);

    const response = await axios.get(`${BASE_URL}/api/get_fee_registers`, {
        params: { year1: academicYear, section_id: searchSection, gr_no: searchGR_No, p_rcpt_date: rcptDate }, } );

    setChildRows(response.data.feeRegData);
    setFeeReceiptRow(response.data.feeRcptData);
    setShowUpdateButtons(true);

  } catch (error) {
    console.error("Fetch Fee Details Error:", error);
    toast.error("Unable to fetch fee details.");
  }
};

const handleChildRowChange = (index, e) => {
  const { name, value } = e.target;

  setChildRows((prevRows) =>
    prevRows.map((row, i) =>
      i === index
        ? { ...row, [name]: value }
        : row
    )
  );
  };
  
  // const handleChildRowUpdate = async (index, type) => {

  //   const row =
  //     type === "fee"
  //       ? childRows[index]
  //       : feeReceiptRow[index];

  //   if (type === "fee") {
  //     if (!row.fee_amt || Number(row.fee_amt) <= 0) {
  //       toast.error("Please enter a valid Fee Amount.");
  //       return;
  //     }

  //     if (!row.install_no || Number(row.install_no) <= 0) {
  //         toast.error("Please enter a valid Installment No.");
  //     return;
  //     }
  //   }

  //   if (type === "receipt") {
  //     if (!row.fee_rcpt_date) {toast.error("Please select Receipt Date.");
  //     return;
  //     }

  //     if (!row.payment_mode) {toast.error("Please select Payment Mode.");
  //     return;
  //     }
  //   }

  //   if (!window.confirm("Update this record?")) return;

  //   const payload = {
  //     year1: Number(academicYear),
  //     section_id: searchSection,
  //     gr_no: searchGR_No,
  //     fee_code: row.fee_code,
  //     old_install_no: row.original_install_no || row.install_no,
  //     install_no: row.install_no,
  //     fee_amt: row.fee_amt,
  //     fee_rcpt_no: row.fee_rcpt_no,
  //     fee_rcpt_date: row.fee_rcpt_date,
  //     payment_mode: row.payment_mode,
  //     updateFee: type === "fee",
  //     updateReceipt: type === "receipt"
  //   };

  //   try {
  //     const response = await axios.post(`${BASE_URL}/api/update_fee_component`,payload);

  //     if (response.data.message === "1") { toast.success("Updated successfully.");        
  //     }
  //    else {toast.error("Unable to update.");      
  //    }

  //   } catch (error) {
  //     console.error("Update Error:", error);
  //     toast.error("Error while updating.");
  //   }
  // };

  const handleReceiptUpdate = async (index) => {

    const row = feeReceiptRow[index];

    if (!row.fee_rcpt_date) {
      toast.error("Please select Receipt Date.");
      return;
    }

    if (!row.payment_mode) {
      toast.error("Please select Payment Mode.");
      return;
    }

    if (!window.confirm("Update this receipt?")) {
      return;
    }

    try {

      const response = await axios.post(`${BASE_URL}/api/update_fee_rcpt`,
        {
          fee_rcpt_date: row.fee_rcpt_date,
          payment_mode: row.payment_mode,
          section_id: row.section_id,
          gr_no: row.gr_no,
          fee_rcpt_no: row.fee_rcpt_no
        }
      );

      if (response.data.message === "1") {
        toast.success("Receipt updated successfully.");
      } else {
        toast.error("Unable to update receipt.");
      }

    } catch (error) {
      console.error("Receipt Update Error:", error);
      toast.error("Error while updating receipt.");
    }
  };

  const handleFeeUpdate = async (index) => {

    const row = childRows[index];

    if (!row.fee_amt || Number(row.fee_amt) <= 0) {
      toast.error("Please enter a valid Fee Amount.");
      return;
    }

    if (!row.install_no || Number(row.install_no) <= 0) {
      toast.error("Please enter a valid Installment No.");
      return;
    }

    if (!window.confirm("Update this fee record?")) {
      return;
    }

    try {

      const payload = {
        year1: Number(academicYear),
        section_id: searchSection,
        gr_no: searchGR_No,
        fee_code: row.fee_code,
        old_install_no: row.original_install_no || row.install_no,
        install_no: row.install_no,
        fee_amt: row.fee_amt
      };

      const response = await axios.post(`${BASE_URL}/api/update_fee_component`, payload);

      if (response.data.message === "1") {
        toast.success("Fee updated successfully.");
      } else {
        toast.error("Unable to update fee.");
      }

    } catch (error) {
      console.error("Fee Update Error:", error);
      toast.error("Error while updating fee.");
    }
  };

  useEffect(() => {
    const fetchLists = async () => {
      try {

        const sectionresult = await axios.get(`${BASE_URL}/api/ddl_sections`);
        setDdlSection(sectionresult.data);

        const year_result = await axios.get(`${BASE_URL}/api/ddl_years`);
        setDdlAcademicYears(year_result.data);

        const feeComp = await axios.get(`${BASE_URL}/api/ddl_fees_desc`);
        setDdlFeeComp(feeComp.data);
        
     
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };
    fetchLists();
  }, []);


  const populateDdlGR = async () => {

    try {

      setSearchGR_No(null);
      setDdlGRNos([]);

      // console.log('searchSection----------', searchSection)

      if (!searchSection) return;

      const studResponse = await axios.get(`${BASE_URL}/api/ddl_stud_name_gr`,
        { params: { p_Section_Id: searchSection } });

      setDdlGRNos(studResponse.data);


    } catch (err) {
      console.error("Dropdown fetch error:", err);
    }

  }

  useEffect(() => {

    const fetchLists = async () => {
      try {

        populateDdlGR();

      } catch (err) {
        console.error("Search fetch error:", err);
      }
    };

    fetchLists();

  }, [searchSection]);


  const handleSearch = () => {

    if (!academicYear || academicYear === "") {
      toast.error("Please select Academic Year.");
      return;
    }

    if (!searchSection || searchSection === "") {
      toast.error("Please select Section.");
      return;
    }

    // if (!searchGR_No || searchGR_No === "") {
    //   toast.error("Please select GR No. / Student Name.");
    //   return;
    // }
    
    fetchFeeDetails(); // Add this line
  };


  const resetPage = () => {

    setIsEditable(false);

    setAcademicYear("");
    setSearchSection("");
    setSearchGR_No("");

    setHeaderData({
      fw_id: '',
      year1: '',
      year2: '',
    });

    setChildRows([
      {
        section_id: '',
        gr_no: '',
        stud_name: '',
        std_div: '',
        existing_fw: '',
        std_id: '',
        div_id: ''
      }
    ]);

    setFeeComponentRows([
      {
        fee_code: '',
        install_no: '',
        fee_amt: ''
      }]);
               
    setFeeReceiptRow([      
      {        
      year1: '',
      section_id: '',
      fee_rcpt_no: '',
      gr_no: '',
      fee_rcpt_date: '',
      payment_mode: '',
      tot_fee_amt: '',
      status: '',
      from_period_name:'',
      to_period_name:''
    }]);

    setErrors({});
    setRowErrors({});
    setShowUpdateButtons(false);
  };

  const handleClear = () => {
    const isConfirmed = window.confirm("Do you want to clear all data?");

    if (!isConfirmed) return;

    setShowUpdateButtons(false);
    resetPage();
  };

  return (

    <Container fluid className="p-3">
      <Card className="p-3 mb-3">
        <Card.Body>

          {/* ================= ROW 1 ================= */}
          <Row className="mb-3">

            {/* Academic Year */}
            <Col md={5}>
              <InputGroup>
                <InputGroup.Text style={{ width: "200px", textAlign:"center" }}>
                  Academic Year
                </InputGroup.Text>

                <Form.Select
                  value={academicYear}
                  onChange={(e) => setAcademicYear(e.target.value)}
                >
                  <option value="">
                    -- Select Academic Year --
                  </option>

                  {ddlAcademicYears.map((year) => (
                    <option
                      key={year.year1}
                      value={year.year1}
                    >
                      {year.disp_year}
                    </option>
                  ))}
                </Form.Select>
              </InputGroup>
            </Col>

            {/* Section */}
            <Col md={5}>
              <InputGroup>
                <InputGroup.Text style={{ width: "100px" }}>
                  Section
                </InputGroup.Text>

                <Form.Select value={searchSection || ""}
                  onChange={(e) => setSearchSection(e.target.value)} >
                  <option value="">-- Select Section -- </option>

                  {ddlSection.map((sec) => (
                    <option key={sec.section_id} value={sec.section_id} > {sec.section_desc} </option>
                  ))}
                </Form.Select>
              </InputGroup>
            </Col>

          </Row>


          {/* ================= ROW 2 ================= */}
          <Row className="mb-3">

            <Col md={10}>
              <InputGroup>
                <InputGroup.Text style={{ width: "200px" }}>
                  GR No. / Student Name
                </InputGroup.Text>

                <div style={{ flex: 1 }}>
                  <Select
                    name="searchGR_No"
                    options={ddlGRNos.map((student) => ({
                      value: String(student.gr_no),
                      label: student.stud_name
                    }))}
                    value={
                      ddlGRNos
                        .map((student) => ({
                          value: String(student.gr_no),
                          label: student.stud_name
                        }))
                        .find(
                          (option) =>
                            String(option.value) === String(searchGR_No)
                        ) || null
                    }
                    // onBlur={handleGRChange}
                    onChange={(selectedOption) =>
                      setSearchGR_No(
                        selectedOption
                          ? selectedOption.value
                          : ""
                      )
                    }
                    placeholder="Search by GR No / Student Name..."
                    isClearable
                  />
                </div>
              </InputGroup>
            </Col>

            <Col md="auto" className="d-flex align-items-center gap-2">
              <Button variant="primary" onClick={handleSearch}
                style={{ width: "145px", height: "42px", fontSize: "15px", fontWeight: "500" }} > Get Fee Details
              </Button>
            </Col>

          </Row>


          {/* ================= ROW 3 ================= */}
          <Row>

            <Col md={10}>

              <InputGroup>
                <InputGroup.Text style={{ width: "150px" }}>
                  Receipt Date 
                </InputGroup.Text>
              <input
                type="date"
                className="form-control"
                value={rcptDate}
                onChange={(e) => setRcptDate(e.target.value)}
              />
                {/* <input className="form-control" name="std_div_name" disabled value={headerData.std_div_name} /> */}
                
              </InputGroup>
            </Col>

            <Col md={2} >

              <Button variant="secondary" onClick={handleClear} 
                   style={{ width: "145px", height: "42px", fontSize: "15px", fontWeight: "500"}} > Clear
              </Button>

            </Col>
          </Row>

        </Card.Body>

      </Card>

      
    {/* <Card className="p-3 mb-3">
    <Card.Header
    className="fw-bold"
    style={{ backgroundColor: "#c3cdf0",color: "black" }}>
    Add Fees Component
  </Card.Header>
        <div className = "table-wrapper" style = {{minHeight: "auto", height: "auto", overflow: "visible"}}>
            <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '15%', textAlign: 'left'}}>Fee Description</th>
                <th style={{ width: '5%', textAlign: 'right'}}>Installment No.</th>
                <th style={{ width: '5%', textAlign: 'right'}}>Fee Amount</th>
              </tr>
            </thead>

            <tbody>
              {feeComponentRows.map((row, index) => (
                <tr key={index}>
                  <td>
                    <Form.Select
                      name="fee_code"
                      value={row.fee_code || ""}
                      onChange={(e) => handleFeeComponentChange(index, e)}
                    >
                      <option value="">-- Select Fee Component --</option>

                      {ddlFeeComp.map((fee) => (
                        <option key={fee.fee_code} value={fee.fee_code}>
                          {fee.fee_desc}
                        </option>
                      ))}
                    </Form.Select>
                  </td>

                  <td>
                    <Form.Control  
                      type="number"
                      name="install_no"
                      value={row.install_no || ""}
                      onChange={(e) => handleFeeComponentChange(index, e)}
                      style={{textAlign: 'right'}}
                    />
                  </td>

                  <td>
                    <Form.Control
                      type="number"
                      name="fee_amt"
                      value={row.fee_amt || ""}
                      onChange={(e) => handleFeeComponentChange(index, e)}
                      style={{textAlign: 'right'}}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="d-flex justify-content-end mt-2">
          <Button
            variant="success"
            size="sm"
            onClick={handleAddFeeComponent}
            style={{
                  width: "200px",
                  fontSize: "16px",
                  fontWeight: "500"
                }}
          >
            Add Fees Component
          </Button>
        </div>
      </Card> */}


      {/* Child Table */}
      {/* <Card className="p-3 mb-3">
        <Card.Header
          className="fw-bold"
          style={{ backgroundColor: "#c3cdf0", color: "black" }}>
          Existing Fees Component
        </Card.Header>

        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: "30%" }}>Fee Description</th>
                <th style={{ width: "12%", textAlign: "center" }}>Installment No.</th>
                <th style={{ width: "11%", textAlign: "center" }}>Bal Flag</th>
                <th style={{ width: "13%", textAlign: "right" }}>Fee Amount</th>
                <th style={{ width: "14%", textAlign: "right" }}>FW Amount</th>
                <th style={{ width: "12%", textAlign: "center" }}>Receipt No</th>
                <th style={{ width: "8%", textAlign: 'center' }}></th>
              </tr>
            </thead>

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  <td>{row.fee_desc}</td>

                  <td>
                    <Form.Control
                      type="number"
                      name="install_no"
                      value={row.install_no || ""}
                      onChange={(e) => handleChildRowChange(index, e)}
                      style={{ textAlign: "right"}}
                    />
                  </td>

                  <td style={{ textAlign: "center" }}>
                    {row.fee_code
                      ? (row.bal_flag === "PAID" ? "PAID" : "PEND")
                      : ""}
                  </td>
                  <td>
                    <Form.Control
                      type="number"
                      name="fee_amt"
                      value={row.fee_amt || ""}
                      onChange={(e) => handleChildRowChange(index, e)}
                      style={{ textAlign: "right" }}
                    />
                  </td>

                  <td style={{ textAlign: "right" }}>{row.fw_amt}</td>

                  <td style={{ textAlign: "right" }}>{row.rcpt_no}</td>

                  <td style={{ textAlign: "center" }}>
                    {showUpdateButtons && (
                    <Button
                      type="button"
                      variant="warning"
                      size="sm"
                       onClick={() => handleFeeUpdate(index)}
                    >
                      Update
                    </Button>
                     )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card> */}

      {/* fee Receipt table */}
      <Card className="p-3 mb-3">
        <Card.Header
          className="fw-bold"
          style={{ backgroundColor: "#c3cdf0", color: "black" }}>
          Fees Reciepts
        </Card.Header>
        {/* <h5>Maintenance Items</h5> */}
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: "8%" }}>Gr No</th>
                <th style={{ width: "8%", textAlign: "center"}}>Receipt No.</th>
                <th style={{ width: "10%", textAlign: "center" }}>Receipt Date</th>
                <th style={{ width: "15%", textAlign: "left" }}>Payment Mode</th>
                <th style={{ width: "10%", textAlign: "left"}}>From Period</th>
                <th style={{ width: "10%", textAlign: "left"}}>To Period</th>
                <th style={{ width: "10%", textAlign: "right"}}>Total Amount</th>
                <th style={{ width: "8%", textAlign: 'left'}}>Status</th>
                <th style={{ width: "8%", textAlign: 'left' }}></th>

              </tr>
            </thead>

            <tbody>
              {feeReceiptRow.map((row, index) => (
                <tr key={index}>
                  <td>{row.gr_no}</td>

                  <td>{row.fee_rcpt_no}</td>

                  <td>
                    <Form.Control
                      type="date"
                      name="fee_rcpt_date"
                      value={row.fee_rcpt_date || ""}
                      onChange={(e) => handleFeeReceiptChange(index, e)}
                      style={{ textAlign: "left" }}
                    />
                  </td>

                  <td style={{ textAlign: "left" }}>
                    <Form.Select name="payment_mode" value={row.payment_mode || ""}
                      onChange={(e) => handleFeeReceiptChange(index, e)} >
                      <option value="">-- Select Payment Mode --</option>
                      <option value="CASH">Cash</option>
                      <option value="CHQ">Cheque/DD</option>
                      <option value="NEFT">NEFT/IMPS</option>
                      <option value="OL">Online</option>
                    </Form.Select>
                  </td>


                  <td style={{ textAlign: "left" }}>{row.from_period_name}</td>

                  <td style={{ textAlign: "left" }}>{row.to_period_name}</td>
                  <td style={{ textAlign: "right" }}>{row.total_amt}</td>

                  <td style={{ textAlign: "left" }}>{row.status}</td>

                  <td style={{ textAlign: "center" }}>
                    {showUpdateButtons && (
                    <Button
                      type="button"
                      variant="warning"
                      size="sm"
                      onClick={() => handleReceiptUpdate(index)}
                    >
                      Update
                    </Button>
                    )}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>


      </Card>

    </Container>
  );
};
export default Edit_Stud_Fees;
